import React from "react";
import logo from "../assets/hero pics.avif";
function Hero() {
  return (
    <section id="home" style={styles.hero}>
      <h1>Advocating for Corruption free lives and Academics.</h1>
      <img
       src={logo}
       alt="unblemished Advocacy Logo?w=600&auto=format&fit=crop&q=60"
       style={styles.logo}
      />
      <p>
        Promoting Integrity in education and inspiring corruption-free living through advocacy and mentorship..
      </p>

      <a href="#about">
        <button style={styles.btn}>About Us</button>
      </a>
    </section>
  );
}

const styles = {
  hero: {
    textAlign: "center",
    padding: "100px 20px",
    background: "#f4f6f9",
    fontSize: "16px"
  },
  logo: {
    width:"300px",
    height: "auto",
    margin: "20px 0"
  },
  btn: {
    marginTop: "20px",
    padding: "10px 20px",
    background: "#000080",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer"
  }
};

export default Hero;